import { toFormat } from '../../../../utils';
import { DataFormatter, FormatterType, UikFormatter, ValueType } from '../models';
import { applyDefaultFormatter } from '.';

/**
 * Returns the formatted value based on the type and/or custom formatter
 * @param value value to be formatted
 * @param valueType type of value
 * @param formatter custom formatter function
 * @returns formatted value as a string
 */
export const formatValue = (value: unknown, valueType: ValueType, formatter?: DataFormatter): string => {
  if (formatter) {
    switch (formatter.type) {
      case FormatterType.UIK:
        const uikFormatter = formatter as UikFormatter;
        return toFormat(uikFormatter.dataType, uikFormatter.formatType, value, uikFormatter.options);
    }
  }
  return applyDefaultFormatter(value, valueType);
};
